import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SessionInfoSingleton } from "../data/singleton/session-info.singleton";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { formatMessage } from "src/app/shared/utils/message.util";
import { environment } from "src/environments/environment";
import { AlertMessage } from "../constants/messages/alert-message";

/**
 * パス「/partitions-tenants」以下のAPIをコールするクラス
 */
@Injectable({
  providedIn: "root",
})
export class PartitionsTenantsApi {
  private readonly ERR_ALERT_TARGET_NAME = "区画・テナント情報";

  /**
   * コンストラクタ
   */
  constructor(
    private httpClient: HttpClient,
    private sessionInfoSingleton: SessionInfoSingleton
  ) {}

  /** POST */
  /**
   * 区画テナント紐付け情報の新規作成
   * - APIパス：/partitions_tenants
   * @param params 内容
   * @returns Observable<Object>型のレスポンス
   */
  createTenants(params: HttpParams): Observable<Object> {
    const url = `${environment.apiUrl}/partitions_tenants`;
    const errorMessage = formatMessage(AlertMessage.FAILED_CREATE_ACTION, {
      target: this.ERR_ALERT_TARGET_NAME,
    });

    return this.httpClient
      .post(url, params, {
        headers: new HttpHeaders({
          Authorization: this.sessionInfoSingleton.getIdToken(),
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      })
      .pipe(
        catchError((error) => {
          alert(errorMessage);
          return error;
        })
      );
  }
}
